import React from 'react'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { Controller, useFormContext } from 'react-hook-form'
import { Grid } from '@material-ui/core'
import PhoneNumber from './phoneNumber'
import { useTranslation } from 'react-i18next'

const UserStep = (props) => {
  const { control, errors } = useFormContext()
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h4">{t('visit.first.title')}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h6">{t('visit.first.label')}</Typography>
      </Grid>
      <Grid item xs={12} lg={10}>
        <Controller
          name="name"
          control={control}
          as={<TextField label={t('visit.second.form.labels.name')} fullWidth error={errors.name} variant="outlined" />}
        />
      </Grid>
      <Grid item xs={12} lg={10}>
        <Controller
          name="surname"
          control={control}
          as={<TextField label={t('visit.second.form.labels.surname')} fullWidth error={errors.surname} variant="outlined" />}
        />
      </Grid>
      <Grid item xs={12} lg={10}>
        <Controller
          name="email"
          control={control}
          as={<TextField label={t('visit.second.form.labels.email')} fullWidth error={errors.email} variant="outlined" />}
        />
      </Grid>
      <PhoneNumber {...props} labelHidden phoneVerification={false} phoneInputName="phone" />
    </Grid>
  )
}

export default UserStep
